import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AOS from "aos";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";


const useStyles = makeStyles((theme) => ({
  container: {
    zIndex: 1,
    width: "100%",
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "5em 2em",
    position: "relative",

    "& .MuiMobileStepper-dots": {
      display: "none",
    },
    "& p": {
      color: "#000",
      margin: 0,
      fontFamily: "Poppins, sans-serif",


    },
    "& h3": {
      fontSize: "55px",
      marginTop: "20px",
      marginBottom: "10px",
      fontWeight: 600,
      lineHeight: 1.2,
      textAlign: "center"
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "1350px",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "1em",
      paddingRight: "1em",
    },
  },
  mainHeading: {
    width: "100%",
    textAlign: "center",
    letterSpacing: "-3.6px",
    fontSize: "92px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    lineHeight: 1.1,
    display: "block",

    [theme.breakpoints.down("md")]: {
      letterSpacing: "-2px",
      fontSize: "80px"
    },
    [theme.breakpoints.down("sm")]: {
      letterSpacing: "-1px",
      fontSize: "34px"
    }
  },
  gradientText: {
    backgroundImage: "linear-gradient(to right, #aa3fff 50%, #f8522e 103%)",
    textAlign: "center",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
  },
  wrapper: {
    background: "white",
  },

  backgroundShape: {
    background: "url('/images/logged_out/bgGradient.png')",
    backgroundSize: "cover",
    height: "100%",
    backgroundPosition: "center center",
    position: "relative",


  },

  sectionTitle: {
    color: "#24282C",
    fontSize: "44px",
    fontWeight: 600,
    textAlign: "center",
    padding: "4rem 0",
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      padding: "4rem 2rem",
    },
  },

  slide: {
    gridColumnGap: "0.4rem",
    backgroundColor: "#f6f3f0",
    borderRadius: "4px",
    alignItems: "center",
    overflow: "auto",
    display: "flex",
    height: "250px",
    margin: "0 1rem",
    padding: "0.5em",

    "& > div": {
      display: "flex",
      padding: "0.5em",

      flexDirection: "column",
      justifyContent: "space-between",
      height: "100%"
    },

    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main, // Change the color to your preference
      borderRadius: "5px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#EDECEC", // Change the color to your preference
      borderRadius: "5px",
    },

    [theme.breakpoints.down("sm")]: {
      gridRowGap: "40px",
      flexDirection: "column",
      padding: "1em"
    }
  },

  title: {
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "Poppins, sans-serif"
  },

  btnLeft: {

  },

  btnRight: {

  },

  testimonialsDescription: {
    marginTop: 0,
    marginBottom: 0,
    fontSize: "16px",
    fontWeight: 500
  },
  stepper: {
    justifyContent: "end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  slideName: {
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "30px",
    display: "flex",
  },
  arrowHolderCircle: {
    width: "48px",
    height: "48px",
    minHeight: "48px",
    minWidth: "48px",
    backgroundColor: "#d8d8d8",
    border: "3px solid #d8d8d8",
    borderRadius: "80px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex"
  },
}));

export default function CardSection() {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 8000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const testimonials = [

    {
      name: "Gia",
      Subject: "Dentistry",
      description:
        "I love this platform and how much more advanced it is compared to other platforms. It gives instant advice in a matter of seconds catered to the individual’s needs. Definitely would recommend. I can’t wait to see the further advancements yet to come! ",
    },
    {
      name: "Laiba",
      Subject: "Medicine",
      description: 
      "I’m a reapplicant and I  got an offer this year, I really think Auralyze helped a lot and made a big difference to my interview performance from last year as the feedback was very useful and the website is amazing. I'd defo recommend it to future medics."
    },
    {
      name: "Saffiya",
      Subject: "Veterinary Medicine",
      description:
        "I like the way feedback is given, it's broken down into different components that I should be able to show in my answers.",
    },
    {
      name: "Simran",
      Subject: "Dentistry",
      description:
        "I loved that it gave me such accurate advice on what to change every time I put my Personal Statement in. When I made these changes, it enhanced the quality of my Personal Statement so much.",
    },
    {
      name: "Christina",
      Subject: "Medicine",
      description:
        "Auralyze offers a wide range of questions you can use to practice and gives you in-depth responses, analysing your communication understanding and reflection. Would recommend using it to any potential applicants!",
    },
    {
      name: "Kyle",
      Subject: "Dentistry",
      description:
        "I think Auralyze.ai is very good, it’s very easy to use and the questions it provides are very similar to those you get in interview which are hard to replicate for yourself! I also think that the quality of feedback is extremely good.",
    },
    {
      name: "Rasha",
      Subject: "Dentistry",
      description:
        "An amazing platform that allows you to practice as many types of interview questions for Dentistry as you like, with instant feedback! Unlike many platforms, the tips for improvement and the feedback given are not generic at all.",
    },
    {
      name: "Saly",
      Subject: "Dentistry",
      description:
        "Auralyze is simply fantastic. It enables you to record yourself answering questions snd get specific feedback scoring you on your content, communication and depth of reflection so that you are able to see your areas of weakness within mere seconds!"
    },
    {
      name: "Qadir",
      Subject: "Dentistry",
      description:
        "Need personalised feedback on your personal statement? Auralyze has got you. Need a cheeky few hundred questions to practice on? Auralyze has got you. Need to do a full interview mock at 4am? Auralyze has got you."
    },
    {
      name: "Farah",
      Subject: "Dentistry",
      description:
        "Auralyze has been vital when studying for my interviews. Not only did it help improve my confidence, and build on my knowledge, but it allowed me to emulate the interview experience without having to pay for expensive courses!"
    },
    {
      name: "Ana",
      Subject: "Dental Hygiene & Therapy",
      description:
        "Auralyze is the perfect tool for any applicants preparing for university interviews. It has a really large question bank, with subject-specific questions and it provides instant feedback on how you could make your answers even better."
    }
  ];


  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Box className={classes.container}>
      <div
        data-aos="fade-up"
        data-aos-easing="ease-out"
        data-aos-delay="550"
      >
        <Typography
          className={classes.mainHeading}
          variant="h2"
          fontWeight={500}
          textAlign="center"
        >
          What our <span className={classes.gradientText}>users</span> are saying
        </Typography>
      </div>



      <div

        data-aos="fade-up"
        data-aos-easing="ease-out"
        data-aos-delay="550"
        style={{ marginTop: "4rem" }}
      >
        <Slider  {...settings}>
          {testimonials.map((step, index) => (
            <div key={index}>
              <div className={classes.slide} key={step.label}>
                <div>
                  <div className={classes.testimonialsDescription}>
                    <p
                    >
                      {step.description}
                    </p>

                  </div>
                  <div className={classes.slideName}>
                    <div>
                      <p className={classes.title}>{step.name}</p>
                      <p style={{ color: "gray", fontWeight: 400, fontSize: "16px" }}>{step.Subject}</p>

                    </div>
                    <div>
                      <img style={{ widhth: "28px" }} src="images/logged_out/quotes.svg" alt="Quotes icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>

      </div>

    </Box>
  );
}
